//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
import FilterFormGroup from '@/components/SkillsInventory/Filters/FilterFormGroup'
import CircularButton from '@/components/Shared/CircularButton.vue'
import GearFill from '~/assets/svg/gear-fill.svg'
export default {
  components: {
    CircularButton,
    GearFill,
    Button,
    FilterFormGroup,
  },
  props: {
    supervisors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
      filters: {
        names: '',
        supervisors: [],
        stateInvitation: [],
      },
      showFilters: false,
    }
  },
  computed: {
    existsSupervisors() {
      return !!this.supervisors.length
    },
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize() {
      this.isExpanded = window.innerWidth <= 435
    },
    onSearch() {
      this.onShowFilters()
      this.$emit('on-search', {
        ...this.filters,
        supervisors: this.filters.supervisors.map((s) => s.key),
        stateInvitation: this.filters.stateInvitation.map((s) => s.value),
      })
    },
    onShowFilters() {
      this.showFilters = !this.showFilters
    },
  },
}
